module.exports = __webpack_public_path__ + "img/christmassweater.f91750cd.png";